import { UserStatus } from "@/api-schema-enums";

export const DEACTIVATED_USER_AVATAR_CLASS_NAME = "opacity-40 grayscale";
export const DEACTIVATED_USER_NAME_CLASS_NAME = "opacity-40";

export function isUserDeactivated(user?: { status?: UserStatus | null } | null): boolean {
  return user?.status === UserStatus.Disabled;
}
